import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-welcome-component',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {
  @Input() content;
}



// WEBPACK FOOTER //
// ./src/app/common/components/WelcomeComponent/welcome.component.ts